<template>
  <div class="container-fluid py-4 px-4 ">
    <!-- Título -->

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-files display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            BOLETAS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTA DE BOLETAS
          </p>
        </div>
      </div>
    </div>

    <div class=" border border-1 rounded-3 p-3 mb-2 ">

      <div class="col-12 d-flex justify-content-end mt-2">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px; width: 100%;">
          <span for="" class="input-group-text mt-3 buscar-estiloCuadrado">
            <i class="bi bi-search"></i></span>
          <input class="form-control w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
            aria-label=".form-control-lg example" placeholder="Nombre Boleta" v-model="filterField" @input="filtro" />
        </div>
      </div>

      <div class="table-responsive mx-2 mt-2">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th>CODTRABAJADOR</th>
              <th>N° BOLETA</th>
              <th>COD. BOLETA</th>
              <th>NOMBRE BOLETA</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>

            <!-- SPINNER -->
            <tr v-if="loading">
              <td colspan="5" class="text-center align-middle" style="height: 260px;">
                <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                  <div class="spinner-border text-warning" style="width: 3.5rem; height: 3.5rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                </div>
              </td>
            </tr>

            <!-- FILAS (solo si no está cargando) -->
            <tr v-else class="text-center align-middle reducirTamaño text-nowrap" v-for="boletitas in bolePaginadas"
              :key="boletitas.id">
              <td>
                <i class="bi bi-person-fill text-primary me-1"></i>
                {{ boletitas.codtrab }}
              </td>

              <!-- N° Boleta -->
              <td>
                <i class="bi bi-file-earmark-text-fill text-success me-1"></i>
                {{ boletitas.iNumBol }}
              </td>

              <!-- Código Boleta -->
              <td>
                <i class="bi bi-hash text-warning me-1"></i>
                {{ boletitas.codNomBol }}
              </td>

              <!-- Nombre Boleta / Concepto -->
              <td class="text-start">
                <i class="bi bi-card-text text-info me-1"></i>
                {{ boletitas.concepto }}
              </td>

              <!-- Acciones -->
             
              <td>
                <b-button @click="datos = boletitas" v-b-modal.modal-center class="btn btn-danger boton-estiloCuadrado">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                </b-button>
              </td>
            </tr>

          </tbody>

        </table>
      </div>
    </div>

    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>
      <span class="pagination-info small">Página {{ currentPage }} de {{ totalPages }}</span>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
        :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>

    <b-modal id="modal-center" centered title="Boletas" no-close-on-backdrop no-close-on-esc>
      <p class="my-4 text-center">¿DESEAS VISUALIZAR SU BOLETA?</p>
      <template #modal-footer>
        <b-button variant="primary" @click="okeyAccion(true)">OK</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
  name: "CopiasMisBoletas",

  data() {
    return {
      boletas: [],
      datos: {},
      currentPage: 1,
      itemsPerPage: 14,
      loading: false,
      filterField: "",
    };
  },

  mounted() {
    const payload = {
      idEmpresa: localStorage.getItem("idEmpresaUsers"),
      idTrabajador: localStorage.getItem("idTrabajdor"),
    };
    console.log(payload);
    this.axios
      .get(`Contrato/ObtenerBoletasTrabajador`, {
        params: payload,
      })
      .then((r) => {
        this.boletas = r.data;
        console.log(r.data);
      });
  },
  computed: {
    boleFiltradas() {
      const filtro = this.filterField.toLowerCase().trim();

      if (!filtro) return this.boletas;

      return this.boletas.filter(b =>
        String(b.codtrab).toLowerCase().includes(filtro) ||
        String(b.iNumBol).toLowerCase().includes(filtro) ||
        String(b.codNomBol).toLowerCase().includes(filtro) ||
        String(b.concepto).toLowerCase().includes(filtro)
      );
    },
    bolePaginadas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.boleFiltradas.slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.boleFiltradas.length / this.itemsPerPage);
    },
  },

  methods: {
    numeroEnLetras(num) {
      const unidades = ['', 'Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve'];
      const especiales = ['Diez', 'Once', 'Doce', 'Trece', 'Catorce', 'Quince', 'Dieciséis', 'Diecisiete', 'Dieciocho', 'Diecinueve'];
      const decenas = ['', '', 'Veinte', 'Treinta', 'Cuarenta', 'Cincuenta', 'Sesenta', 'Setenta', 'Ochenta', 'Noventa'];
      const centenas = ['', 'Ciento', 'Doscientos', 'Trescientos', 'Cuatrocientos', 'Quinientos', 'Seiscientos', 'Setecientos', 'Ochocientos', 'Novecientos'];

      if (num === 0) return 'Son: Cero Soles';

      const convertirCentenas = (n) => {
        let texto = '';
        if (n === 100) return 'Cien';
        if (n > 100) {
          texto += centenas[Math.floor(n / 100)] + ' ';
          n %= 100;
        }
        if (n >= 10 && n < 20) {
          texto += especiales[n - 10];
        } else {
          if (n >= 20) {
            texto += decenas[Math.floor(n / 10)];
            if (n % 10 !== 0) {
              texto += ' y ' + unidades[n % 10];
            }
          } else if (n > 0) {
            texto += unidades[n];
          }
        }
        return texto.trim();
      };

      const convertirMiles = (n) => {
        let texto = '';
        if (n >= 1000000) {
          texto += convertirMiles(Math.floor(n / 1000000)) + ' Millón ';
          n %= 1000000;
        }
        if (n >= 1000) {
          if (Math.floor(n / 1000) === 1) {
            texto += 'Mil ';
          } else {
            texto += convertirCentenas(Math.floor(n / 1000)) + ' Mil ';
          }
          n %= 1000;
        }
        texto += convertirCentenas(n);
        return texto.trim();
      };

      // Separar parte entera y decimal
      const partes = num.toString().split('.');
      const entero = parseInt(partes[0], 10);
      const decimales = partes[1] ? partes[1].padEnd(2, '0') : '00';

      const letras = convertirMiles(entero);
      return `Son: ${letras} y ${decimales}/100 Soles`;

    },

    okeyAccion(numero) {

      const from = {
        codtrab: this.datos.codtrab,
        iNumBol: this.datos.iNumBol,
        CodNomBol: this.datos.codNomBol,
        idUsuario: localStorage.getItem("userId"),
        validacion: numero
      }
      console.log(from)

      // Puedes poner aquí tu lógica
      this.axios.post(`Contrato/ValidarVisualizacionBoleta`, from).then(r => {
        console.log(r.data)
        if (r.data.mensaje) {
          Swal.fire(
            "Se firmó y se aceptó la visualización de la boleta",
            "",
            "success"
          ).then((result) => {
            if (result.isConfirmed) {
              this.$bvModal.hide('modal-center');
              this.PdfCreate(this.datos, r.data.fecha);
            }
          });


        } else {
          // Swal.fire(`NO se firmó y NO se aceptó la visualización de la boleta`, "", "success");
          this.$bvModal.hide('modal-center');

        }
      })

    },

    PdfCreate(data, fecha) {
      console.log(data);
      const params = {
        idEmpresa: localStorage.getItem("idEmpresaUsers"),
        idTrabajador: localStorage.getItem("idTrabajdor"),
        FLG_VERNOAFECTOS: false,
        inumBol: `${data.iNumBol}`,
      };

      this.axios
        .get(`Contrato/ObtenerBoletasXTrabajador`, { params })
        .then((r) => {
          console.log("datos del trabajador", r.data);
          console.log(r.data);

          const formulario = {
            // nombreBoleta: r.data[0].cronogramaPago,
            // nombreTrabajador: data.nombreCompleto,
            // codigoTrabajador: data.codtrab,
            // FechaIngreso: data.fecIngreso,
            // cargo: data.puesto,
            // nomCentroCosto: data.centroCosto,
            // fechaPago: data.fecPago ? data.fecPago : 0,
            // FondoPensiones: data.fondoPensiones,
            // Remuneracion: data.sueldo,
            // RemuneracionMensual: r.data[0].remens,
            // documento: data.docIdentidad,
            // situacion: data.situacion,
            // cuentaBancaria: data.banco,
            // RemuneracionVacaciones: r.data[0].remuvac,
            // RemuneracionGratificacion: r.data[0].remugrat,
            // diasVacaciones: r.data[0].diasvaca,
            // diasFalta: r.data[0].diasfalt,
            // diasTrabajados: r.data[0].diastrab,
            // afpAportacion1: r.data[0].afP00001,
            // afpAportacion2: r.data[0].afP00002,
            // afpAportacion3: r.data[0].afP00003,
            // movilidad: r.data[0].movilida,
            // egresos: r.data[0].totegr,
            // totalIngresos: r.data[0].toting,
            // totalNeto: r.data[0].neto,
            // adelValeAlim: r.data[0].adelvale,
            // valeAlimentos: r.data[0].valealm,
            // Bon29351: r.data[0].boN29351,
            // sistemaSalud: r.data[0].sns,
            // comisiones: r.data[0].comision,
            // adelantoRemun: r.data[0].syS_ADEL,
            // diasSubSidiados: r.data[0].diassubs,
            // SubIncaEnfer: r.data[0].sbincap,
            // impuestRenta5ta: r.data[0].iR5TACTG,
            // totalTexto: this.numeroEnLetras(r.data[0].neto),
            // rucEmpresa: data.empRuc,
            // nombreEmpresa: data.empRazSocial,
            // direccionEmpresa: data.empDireccion,
            // nombreRepresentante: data.nomRepresentante,
            // iNumBol: data.iNumBol,
            // codNomBol: data.codNomBol,
            // fecha: fecha
            iNumBol: data.iNumBol,
            codNomBol: data.codNomBol,
            nombreBoleta: r.data[0].cronogramaPago,
            nombreTrabajador: data.nombreCompleto,
            codigoTrabajador: data.codtrab,
            FechaIngreso: data.fecIngreso,
            cargo: data.puesto,
            nomCentroCosto: data.centroCosto,
            fechaPago: data.fecPago ? data.fecPago : 0,
            FondoPensiones: data.fondoPensiones,
            Remuneracion: data.sueldo,
            RemuneracionMensual: r.data[0].remens,
            documento: data.docIdentidad,
            situacion: data.situacion,
            cuentaBancaria: data.banco,
            diasTrabajados: r.data[0].diastrab,
            diasVacaciones: r.data[0].diasvaca,
            afpAportacion1: r.data[0].afP00001,
            afpAportacion2: r.data[0].afP00002,
            afpAportacion3: r.data[0].afP00003,
            movilidad: r.data[0].movilida,
            egresos: r.data[0].totegr,
            totalIngresos: r.data[0].toting,
            totalNeto: r.data[0].neto,
            adelValeAlim: r.data[0].adelvale,
            valeAlimentos: r.data[0].valealm,
            comisiones: r.data[0].comision,
            adelantoRemun: r.data[0].syS_ADEL,
            AsigFamiliar: r.data[0].asifame,
            sistemaSalud: r.data[0].sns,
            impuestRenta5ta: r.data[0].iR5TACTG,
            HorasExtras25: r.data[0].horasext,
            HorasExtras35: r.data[0].hoE35,
            HorasExtras100: r.data[0].horaS100,
            IngresoHorasExtra25: r.data[0].inghe,
            IngresoHorasExtra35: r.data[0].montO35,
            IngresoHorasExtra100: r.data[0].innghE10,
            BonificacionNocturna: r.data[0].noctur,
            EpsRimac: r.data[0].egeps,
            Bon29351: r.data[0].boN29351,
            RemuneracionGratificacion: r.data[0].remugrat,
            RemuneracionVacaciones: r.data[0].remuvac,
            diasFalta: r.data[0].diasfalt,
            diasSubSidiados: r.data[0].diassubs,
            SubIncaEnfer: r.data[0].sbincap,
            diasMesAnterior: r.data[0].regdias,
            AntecedentesPena: r.data[0].antcpe,
            utilidad: r.data[0].utilidad,
            diasDescanso: r.data[0].ddmed,
            idEmpresa: localStorage.getItem("idEmpresaUsers"),
            rucEmpresa: data.empRuc,
            nombreEmpresa: data.empRazSocial,
            direccionEmpresa: data.empDireccion,
            fecha: fecha,
          };
          console.log("formulario", formulario);

          this.axios
            .get("Contrato/GenerarBoletaPdfs", {
              params: {
                iNumBol: data.iNumBol,
                codNomBol: data.codNomBol,
                nombreBoleta: r.data[0].cronogramaPago,
                nombreTrabajador: data.nombreCompleto,
                codigoTrabajador: data.codtrab,
                FechaIngreso: data.fecIngreso,
                cargo: data.puesto,
                nomCentroCosto: data.centroCosto,
                fechaPago: data.fecPago ? data.fecPago : 0,
                FondoPensiones: data.fondoPensiones,
                Remuneracion: data.sueldo,
                RemuneracionMensual: r.data[0].remens,
                documento: data.docIdentidad,
                situacion: data.situacion,
                cuentaBancaria: data.banco,
                diasTrabajados: r.data[0].diastrab,
                diasVacaciones: r.data[0].diasvaca,
                afpAportacion1: r.data[0].afP00001,
                afpAportacion2: r.data[0].afP00002,
                afpAportacion3: r.data[0].afP00003,
                movilidad: r.data[0].movilida,
                egresos: r.data[0].totegr,
                totalIngresos: r.data[0].toting,
                totalNeto: r.data[0].neto,
                adelValeAlim: r.data[0].adelvale,
                valeAlimentos: r.data[0].valealm,
                comisiones: r.data[0].comision,
                adelantoRemun: r.data[0].syS_ADEL,
                AsigFamiliar: r.data[0].asifame,
                sistemaSalud: r.data[0].sns,
                impuestRenta5ta: r.data[0].iR5TACTG,
                HorasExtras25: r.data[0].horasext,
                HorasExtras35: r.data[0].hoE35,
                HorasExtras100: r.data[0].horaS100,
                IngresoHorasExtra25: r.data[0].inghe,
                IngresoHorasExtra35: r.data[0].montO35,
                IngresoHorasExtra100: r.data[0].innghE10,
                BonificacionNocturna: r.data[0].noctur,
                EpsRimac: r.data[0].egeps,
                Bon29351: r.data[0].boN29351,
                RemuneracionGratificacion: r.data[0].remugrat,
                RemuneracionVacaciones: r.data[0].remuvac,
                diasFalta: r.data[0].diasfalt,
                diasSubSidiados: r.data[0].diassubs,
                SubIncaEnfer: r.data[0].sbincap,
                diasMesAnterior: r.data[0].regdias,
                AntecedentesPena: r.data[0].antcpe,
                utilidad: r.data[0].utilidad,
                diasDescanso: r.data[0].ddmed,
                idEmpresa: localStorage.getItem("idEmpresaUsers"),
                rucEmpresa: data.empRuc,
                nombreEmpresa: data.empRazSocial,
                direccionEmpresa: data.empDireccion,
                fecha: fecha,

                // totalTexto: this.numeroEnLetras(r.data[0].neto),

                // nombreRepresentante: data.nomRepresentante,


              },
              responseType: "blob", 
            })
            .then((response) => {
            
              const url = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "BoletaPago_Julio2025.pdf"); // nombre que tendrá el archivo
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url); // liberar recurso
            })
            .catch((error) => {
              console.error("Error al descargar el PDF:", error);
            });
        });
    },
    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);

    },
  },
};
</script>
<style scoped>
.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>
